"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.richToolbar = exports.basicToolbar = void 0;
// Toolbar options
const sizes = [{
  header: [false, 1, 2, 3, 4, 5, 6]
}];
const decorations = ['bold', 'italic', 'underline'];
const lists = [{
  list: 'bullet'
}, {
  list: 'ordered'
}, {
  indent: '+1'
}, {
  indent: '-1'
}];
const alignments = [{
  align: ''
}, {
  align: 'center'
}, {
  align: 'right'
}, {
  align: 'justify'
}];
const link = 'link';
// const image = 'image'

const basicToolbar = exports.basicToolbar = [decorations, lists];
const richToolbar = exports.richToolbar = [sizes, decorations, lists, alignments, [link]];